import {API_URL, authHeaders, jsonHeaders} from "./index";

export async function apiGetPosts(groupId) {
    const res = await fetch(`${API_URL}/groups/${groupId}/posts`);
    return res.json();
}

export async function apiCreatePost(groupId, content, isAnonymous, realName) {
    const res = await fetch(`${API_URL}/groups/${groupId}/posts`, {
        method: "POST",
        headers: jsonHeaders(),
        body: JSON.stringify({content, is_anonymous: isAnonymous, real_name: realName})
    });
    return res.json();
}

export async function apiDeletePost(postId) {
    const res = await fetch(`${API_URL}/posts/${postId}`, {
        method: "DELETE",
        headers: authHeaders()
    });
    return res.json();
}

export async function apiLikePost(postId) {
    const res = await fetch(`${API_URL}/posts/${postId}/like`, {
        method: "POST",
        headers: authHeaders()
    });
    return res.json();
}
